var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchmain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 54,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3629 12.8561C14.6083 11.4903 15.3689 9.67399 15.3689 7.68461C15.3689 3.44766 11.9217 5.20047e-09 7.68444 5.20047e-09C3.44718 -0.000154609 0 3.4473 0 7.68421C0 11.9212 3.44722 15.3688 7.68444 15.3688C9.67458 15.3688 11.4902 14.6082 12.8562 13.3628L19.3883 19.895C19.5283 20.035 19.7549 20.035 19.895 19.895C20.035 19.755 20.035 19.5284 19.895 19.3883L13.3629 12.8561ZM7.6844 14.6524C3.84206 14.6524 0.716619 11.5266 0.716619 7.68445C0.716619 3.84203 3.84222 0.716119 7.6844 0.716119C11.5266 0.716119 14.6522 3.84195 14.6522 7.68445C14.6522 11.5264 11.5263 14.6524 7.6844 14.6524Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchmain);
export default __webpack_public_path__ + "static/media/searchmain.7bb25520c1186737fc760cc39fdb98fb.svg";
export { ForwardRef as ReactComponent };